import type { OrderContactAddressDto } from "@/api/types";
import { translations } from "@/constants/translations";
import { renderInnerHtml } from "@/helpers/dom";
import { useStore } from "@/store";
import type { TableCellProps, TableColumnHeaderProps } from "@chakra-ui/react";
import {
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Box,
  Checkbox,
} from "@chakra-ui/react";
import { observer } from "mobx-react";
import React from "react";

interface Props {
  data: OrderContactAddressDto[];
  onSelect: (item: OrderContactAddressDto) => unknown;
  selectedId?: number;
}

const Head = (props: TableColumnHeaderProps) => {
  return (
    <Th
      width="120px"
      py="5"
      fontSize="14px"
      fontWeight="700"
      color="white"
      textAlign="center"
      textTransform="none"
      {...props}
    />
  );
};

const Cell = (props: TableCellProps) => {
  return (
    <Td
      fontSize="14px"
      style={{
        whiteSpace: "normal",
      }}
      textAlign="center"
      {...props}
    />
  );
};

export const OrderAddressTable = observer(
  ({ data, onSelect, selectedId }: Props) => {
    const { activeLanguage } = useStore();
    const language = translations.common["address-table"][activeLanguage];
    const provinceLanguage =
      translations.common["provinces-fullName"][activeLanguage];

    return (
      <Box
        maxH="400px"
        width="100%"
        overflow="auto"
      >
        <TableContainer>
          <Table
            variant="simple"
            layout="fixed"
          >
            <Thead>
              <Tr bg="#4D4D4F">
                <Head width="50px"></Head>
                <Head>{renderInnerHtml(language.name)}</Head>
                <Head>{renderInnerHtml(language.business_name)}</Head>
                <Head>{renderInnerHtml(language.street_address)}</Head>
                <Head>{renderInnerHtml(language.unit)}</Head>
                <Head>{renderInnerHtml(language.city)}</Head>
                <Head>{renderInnerHtml(language.province)}</Head>
                <Head>{renderInnerHtml(language.postal_code)}</Head>
              </Tr>
            </Thead>
            <Tbody>
              {data.map((item) => (
                <Tr
                  key={item.id}
                  _odd={{ bg: "#2E2E30" }}
                  cursor="pointer"
                  onClick={() => onSelect(item)}
                  color={selectedId === item.id ? "primary-light" : undefined}
                >
                  <Cell>
                    <Checkbox
                      isChecked={selectedId === item.id}
                      size="lg"
                    />
                  </Cell>
                  <Cell>{item.name}</Cell>
                  <Cell>{item.businessName}</Cell>
                  <Cell>{item.streetAddress}</Cell>
                  <Cell>{item.unitSuiteEtc}</Cell>
                  <Cell>{item.city}</Cell>
                  <Cell>
                    {activeLanguage === "english"
                      ? item.province
                      : (provinceLanguage as any)[item.province]}
                  </Cell>
                  <Cell>{item.postalCode}</Cell>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      </Box>
    );
  },
);
